<app-topbar></app-topbar>
<app-sidebar></app-sidebar>
<div style="min-height: 100vh" class="app-content content">
  <div class="content-wrapper">
    <div class="content-header">
      <div class="page-head">
        <div>
          <h3 class="page-head__title">{{ title || "Transfer Commission logs" }}</h3>
          <p class="page-head__sub">Monitor and manage transfer commission records.</p>
        </div>
        <div class="page-head__tools">
          <span class="page-pill">
            <i class="fa fa-exchange"></i> {{ transferLogs?.length }} records
          </span>
          @if (details?.permission === 'admin') {
            <span class="page-pill page-pill--balance">
              <i class="fa fa-money"></i> Current Balance
              <strong>NGN {{ $safeNavigationMigration(details?.agent?.balance) | number }}</strong>
            </span>
          }
        </div>
      </div>
    </div>

    <div class="content-body">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header card-toolbar">
              <h4 class="card-toolbar__title">
                <i class="fa fa-exchange"></i> Transfer Commission
                <span class="count-pill">{{ transferLogs?.length }}</span>
              </h4>
              <div class="card-toolbar__actions">
                <app-initialize-transfer-commission
                  (transferDetailLogs)="handleTransferDetailLogs($event)"
                ></app-initialize-transfer-commission>
                <button
                  class="btn btn-outline-success btn-round"
                  type="button"
                  (click)="exportReports()"
                  >
                  <i class="fa fa-download"></i> Download Report
                </button>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive table-scroll">
                @if (transferLogs?.length > 0) {
                  <table
                    class="table table-de mb-0"
                    style="padding: 70px"
                    >
                    <thead>
                      <tr>
                        <th (click)="sortOrders('transaction_ref')">
                          Transaction Reference
                        </th>
                        <th>Bank Name</th>
                        <th>Account Number</th>
                        <th>Beneficiary Name</th>
                        <th>Currency</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Narration</th>
                        <th>Status</th>
                        <th>Message</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (
                        transaction of transferLogs | paginate : config
                        ; track
                        transaction) {
                        <tr
                          class="pull-up myBox"
                      [routerLink]="[
                        '/transaction',
                        $safeNavigationMigration(transaction?.transaction_ref)
                      ]"
                          >
                          <td>{{ transaction?.reference }}</td>
                          <td>{{ transaction?.bank_name }}</td>
                          <td>{{ transaction?.account_number }}</td>
                          <td>{{ transaction?.beneficiary_name }}</td>
                          <td>{{ transaction?.currency }}</td>
                          <td>
                            <span class="text-bold-600">₦{{ $safeNavigationMigration(transaction?.amount) | number }}</span>
                          </td>
                          <td>{{ $safeNavigationMigration(transaction?.created_at) | date }}</td>
                          <td>{{ transaction?.narration }}</td>
                          <td>
                            <span
                          class="status-badge status-{{
                            $safeNavigationMigration(transaction?.status) | lowercase
                          }}"
                              >
                              {{ $safeNavigationMigration(transaction?.status) | uppercase }}
                            </span>
                          </td>
                          <td>{{ transaction?.message }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                }
              </div>
              @if (transferLogs?.length >= 1) {
                <div
                  style="text-align: center; width: 100%"
                  >
                  <pagination-controls
                    (pageChange)="pageChanged($event)"
                  ></pagination-controls>
                </div>
              }
              @if (transferLogs?.length === 0) {
                <div
                  class="alert alert-light"
                  style="color: white; margin: 0 15px 15px 15px"
                  >
                  {{ emptyTransactionMessage }}
                </div>
              }
            </div>
            <!-- Close card-content -->
          </div>
          <!-- Close card -->
        </div>
        <!-- Close col-12 -->
      </div>
      <!-- Close row -->
    </div>
    <!-- Close content-body -->
  </div>
  <!-- Close content-wrapper -->
</div>
<!-- Close app-content -->
<app-bottombar></app-bottombar>
